module.exports = __webpack_public_path__ + "static/img/202209.b56eb42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/202209.jpg
// module id = q88Q
// module chunks = 0